module.exports = __webpack_public_path__ + "static/media/facial-capture-loading-white.ab1e8e79.svg";